import React, {Component} from 'react';
import * as hooks from "../../../../../utils/hooks";
import * as func from "../../../../../utils/functions";
import ReactPaginate from "react-paginate";
import {BASE_PATH} from "../../../../../wpconfig";
import {NavLink} from "react-router-dom";
import {objectToQueryString, pushUrl} from "../../../../../utils/functions";
import Loading from "../../../../etc/loading";
import {Doughnut} from "react-chartjs-2";
import DoughnutChart from "../../../../etc/DoughnutChart";

class MAChart extends Component {
	constructor(props) {
		super(props);

		// this.state = {
		// 	activeTab: 'all',
		// 	categoryType: 'register_type',
		// 	categoryName: null
		// }
		//
		// func.getData("code/search/" + this.state.categoryType, {}).then((response) => {
		// 	let categoryName = {};
		// 	response.records.map((r, i) => {
		// 		categoryName[r.code_id] = r.code_name;
		// 	});
		// 	this.setState({categoryName: categoryName});
		// });
	}

	render() {
		const stats = this.props.stats;

		if (!stats)
			return '';

		const sci = {};
		if(stats.resource_subject.jcr_category) {
			sci.title = 'SCI급';
			sci.labels = [];
			sci.data = [];
			sci.color = ['#40404f' , '#837fcc' , '#9baae8' , '#bacbe9'];
			stats.resource_subject.jcr_category.map((item, index) => {
				sci.labels.push(item.category_name)
				sci.data.push(item.count)
			});
		}

		const scopus = {};
		if(stats.resource_subject.scopus_category) {
			scopus.title = 'Scopus';
			scopus.labels = [];
			scopus.data = [];
			scopus.color = ['#3d2b21' , '#c75b2f' , '#cc9c60' , '#dac683'];
			stats.resource_subject.scopus_category.map((item, index) => {
				scopus.labels.push(item.category_name)
				scopus.data.push(item.count)
			});
		}

		const kci = {};
		if(stats.resource_subject.kci_category) {
			kci.title = 'KCI';
			kci.labels = [];
			kci.data = [];
			kci.color = ['#313d3b' , '#448d9b' , '#78b1a7' , '#9ccbb7'];
			stats.resource_subject.kci_category.map((item, index) => {
				kci.labels.push(item.category_name)
				kci.data.push(item.count)
			});
		}

		return (
			<div className="mt-65">
				<div className="d-flex justify-content-between align-items-center mb-px-26">
					<div className="d-flex align-items-center">
						<h3 className="con-title">연구동향 분석</h3>
					</div>
				</div>
				{/*<div className="d-flex align-items-center mb-3">*/}
				{/*<button className="btn-tab-nav mr-1 active-color-lightblue active">연구동향</button>*/}
				{/*<button className="btn-tab-nav mr-1 active-color-lightblue">논문의 주제분야</button>*/}
				{/*</div>*/}
				<div>
					{/*<div className="tab-data active">연구동향</div>*/}
					<div className="tab-data active">
						<div className="row row-cols-3 ml-px-n12 mr-px-n12">
							<div className="pl-px-12 pr-px-12">
								<div className="doughnut-chart-wrap">
									<div className="chart-inner">
										<div className="chartjs-size-monitor">
											<div className="chartjs-size-monitor-expand">
												<div/>
											</div>
											<div className="chartjs-size-monitor-shrink">
												<div/>
											</div>
										</div>
										<div className="chart-title">SCI급</div>
										<DoughnutChart record={sci} />
									</div>
								</div>
							</div>
							<div className="pl-px-12 pr-px-12">
								<div className="doughnut-chart-wrap">
									<div className="chart-inner">
										<div className="chartjs-size-monitor">
											<div className="chartjs-size-monitor-expand">
												<div/>
											</div>
											<div className="chartjs-size-monitor-shrink">
												<div/>
											</div>
										</div>
										<div className="chart-title">Scopus</div>
										<DoughnutChart record={scopus} />
									</div>
								</div>
							</div>
							<div className="pl-px-12 pr-px-12">
								<div className="doughnut-chart-wrap">
									<div className="chart-inner">
										<div className="chartjs-size-monitor">
											<div className="chartjs-size-monitor-expand">
												<div/>
											</div>
											<div className="chartjs-size-monitor-shrink">
												<div/>
											</div>
										</div>
										<div className="chart-title">KCI</div>
										<DoughnutChart record={kci} />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div id="DoughnutChartToolTip" className="doughnut-chart-tooltip" />
			</div>
		);
	}
};

export default MAChart;
